import { render, staticRenderFns } from "./JobberList.vue?vue&type=template&id=8407bf6c"
import script from "./JobberList.vue?vue&type=script&lang=js"
export * from "./JobberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports